import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initializeAnalytics = () => {
  if (!MEASUREMENT_ID) return;
  ReactGA.initialize(MEASUREMENT_ID, {
    gaOptions: {
      debug_mode: process.env.NODE_ENV === 'development', // Enable debug mode in development
    },
  });
};

// Track page views
export const trackPageView = (path, title, userStatus = 'anonymous') => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title,
    custom_map: {
      custom_parameter_1: 'user_status',
      custom_parameter_2: 'user_id',
    },
    custom_parameters: {
      user_status: userStatus,
    },
  });
};

// Set user ID for authenticated users
export const setUserId = (userId) => {
  ReactGA.set({ user_id: userId });
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  ReactGA.event(eventName, parameters);
};

// Authentication Events
export const trackAuthEvent = (action, method = 'email', status = 'success') => {
  trackEvent('auth_interaction', {
    action: action, // 'sign_up', 'login', 'logout'
    method: method,
    status: status,
  });
};

// Property Interaction Events
export const trackPropertyEvent = (action, propertyId = null, propertyData = {}) => {
  trackEvent('property_interaction', {
    action: action, // 'view', 'save', 'unsave', 'share'
    property_id: propertyId,
    property_price: propertyData.price,
    property_location: propertyData.location,
    property_type: propertyData.type,
  });
};

// Search Events
export const trackSearchEvent = (searchFilters = {}) => {
  trackEvent('search_performed', {
    search_type: searchFilters.type || 'property',
    location: searchFilters.location,
    price_min: searchFilters.priceMin,
    price_max: searchFilters.priceMax,
    bedrooms: searchFilters.bedrooms,
    bathrooms: searchFilters.bathrooms,
  });
};

// Buy Box Events
export const trackBuyBoxEvent = (action, buyBoxData = {}) => {
  trackEvent('buy_box_interaction', {
    action: action, // 'initiated', 'completed', 'abandoned'
    criteria_count: buyBoxData.criteriaCount,
    price_range_min: buyBoxData.priceMin,
    price_range_max: buyBoxData.priceMax,
    locations: buyBoxData.locations?.join(',') || '',
  });
};

// Conversion Funnel Events
export const trackConversionEvent = (step, fromStep = null) => {
  trackEvent('conversion_funnel', {
    step: step, // 'visit', 'search', 'property_view', 'sign_up', 'buy_box_setup'
    from_step: fromStep,
    timestamp: new Date().toISOString(),
  });
};

// User Engagement Events
export const trackEngagement = (type, duration = null, element = null) => {
  trackEvent('user_engagement', {
    engagement_type: type, // 'scroll', 'click', 'form_focus', 'time_on_page'
    duration_seconds: duration,
    element: element,
  });
};

// Error Tracking
export const trackError = (errorType, errorMessage, context = {}) => {
  trackEvent('error_occurred', {
    error_type: errorType,
    error_message: errorMessage,
    context: JSON.stringify(context),
  });
};

export default {
  initializeAnalytics,
  trackPageView,
  setUserId,
  trackEvent,
  trackAuthEvent,
  trackPropertyEvent,
  trackSearchEvent,
  trackBuyBoxEvent,
  trackConversionEvent,
  trackEngagement,
  trackError,
};
